module.exports = __webpack_public_path__ + "img/titleEle.04797363.svg";